import vue from 'vue'
export default new vue()


// WEBPACK FOOTER //
// ./src/components/PersonalCenter/components/navlistBus.js